import type { PaymentFailAction, PaymentSuccessAction } from '../cart/cart'
import { WebshopPackage } from '../../../schema/webshop-package'
import { BasketItem } from '../../../schema/basket'
import { InvoiceAddress, PaymentMethod, PaymentParams } from '../../../schema/payment'

export const ADD_PRODUCT_FAIL = 'webshop/ADD_PRODUCT_FAIL' as const
export const ADD_PRODUCT_SUCCESS = 'webshop/ADD_PRODUCT_SUCCESS' as const
export const ADD_PRODUCT = 'webshop/ADD_PRODUCT' as const
export const FETCH_PACKAGES = 'webshop/FETCH_PACKAGES' as const
export const FETCH_HIDDEN_PACKAGES = 'webshop/FETCH_HIDDEN_PACKAGES' as const
export const GET_BASKET = 'webshop/GET_BASKET' as const
export const GET_BASKET_SUCCESS = 'webshop/GET_BASKET_SUCCESS' as const
export const HIDE_NOTIFICATION = 'webshop/HIDE_NOTIFICATION' as const
export const PURGE_BASKET = 'webshop/PURGE_BASKET' as const
export const REBUILD_WEBSHOP = 'webshop/REBUILD_WEBSHOP' as const
export const REMOVE_PRODUCT_FROM_BASKET = 'webshop/REMOVE_PRODUCT_FROM_BASKET' as const
export const REMOVE_PRODUCT_FROM_BASKET_SUCCESS = 'webshop/REMOVE_PRODUCT_FROM_BASKET_SUCCESS' as const
export const SET_BASKET_PRODUCTS = 'webshop/SET_BASKET_PRODUCTS' as const
export const SET_PACKAGES = 'webshop/SET_PACKAGES' as const
export const SET_HIDDEN_PACKAGES = 'webshop/SET_HIDDEN_PACKAGES' as const
export const SHOW_NOTIFICATION = 'webshop/SHOW_NOTIFICATION' as const
export const START_PAYMENT = 'webshop/START_PAYMENT' as const

type FetchPackagesAction = {
  type: typeof FETCH_PACKAGES,
}

type FetchHiddenPackagesAction = {
  type: typeof FETCH_HIDDEN_PACKAGES,
}

export type SetPackagesAction = {
  payload: Array<WebshopPackage>,
  type: typeof SET_PACKAGES,
}

export type SetHiddenPackagesAction = {
  payload: Array<WebshopPackage>,
  type: typeof SET_HIDDEN_PACKAGES,
}

export type AddProductToBasketAction = {
  payload: WebshopPackage,
  type: typeof ADD_PRODUCT,
}

export type AddProductToBasketSuccessAction = {
  payload: WebshopPackage,
  type: typeof ADD_PRODUCT_SUCCESS,
}

export type AddProductToBasketFailAction = {
  type: typeof ADD_PRODUCT_FAIL,
}

export type GetBasketAction = {
  type: typeof GET_BASKET,
}

export type GetBasketSuccessAction = {
  payload: { 
    items: BasketItem[],
    vatTotal: number
  },
  type: typeof GET_BASKET_SUCCESS
}

export type SetBasketProductsAction = {
  payload: BasketItem[],
  type: typeof SET_BASKET_PRODUCTS,
}

export type RemoveProductFromBasketAction = {
  payload: WebshopPackage,
  type: typeof REMOVE_PRODUCT_FROM_BASKET,
}

export type RemoveProductFromBasketSuccessAction = {
  type: typeof REMOVE_PRODUCT_FROM_BASKET_SUCCESS,
}

export type PurgeBasketAction = {
  type: typeof PURGE_BASKET,
}

export type StartPaymentAction = {
  payload: {
    paymentMethod: PaymentMethod,
    paymentParams?: PaymentParams,
    poNumber?: string,
    invoiceAddress?: InvoiceAddress,
  },
  type: typeof START_PAYMENT,
}

export type RebuildWebshopAction = {
  payload: {
    productCodes: Array<string>,
    paymentAction?: PaymentFailAction | PaymentSuccessAction,
  },
  type: typeof REBUILD_WEBSHOP,
}

export type WebshopActions =
  | AddProductToBasketAction
  | AddProductToBasketFailAction
  | AddProductToBasketSuccessAction
  | FetchPackagesAction
  | FetchHiddenPackagesAction
  | GetBasketAction
  | GetBasketSuccessAction
  | PurgeBasketAction
  | RebuildWebshopAction
  | SetBasketProductsAction
  | SetPackagesAction
  | SetHiddenPackagesAction
  | StartPaymentAction
  | RemoveProductFromBasketAction
  | RemoveProductFromBasketSuccessAction

export const fetchPackages = (): FetchPackagesAction => ({
  type: FETCH_PACKAGES,
})

export const fetchHiddenPackages = (): FetchHiddenPackagesAction => ({
  type: FETCH_HIDDEN_PACKAGES,
})

export const setPackages = (
  packages: Array<WebshopPackage>,
): SetPackagesAction => ({
  payload: packages,
  type: SET_PACKAGES,
})

export const setHiddenPackages = (
  packages: Array<WebshopPackage>,
): SetHiddenPackagesAction => ({
  payload: packages,
  type: SET_HIDDEN_PACKAGES,
})

export const addProductToBasket = (
  product: WebshopPackage
): AddProductToBasketAction => ({
  payload: product,
  type: ADD_PRODUCT,
})

export const addProductToBasketSuccess = (
  product: WebshopPackage,
): AddProductToBasketSuccessAction => ({
  payload: product,
  type: ADD_PRODUCT_SUCCESS,
})

export const addProductToBasketFail = (): AddProductToBasketFailAction => ({
  type: ADD_PRODUCT_FAIL,
})

export const getBasket = (): GetBasketAction => ({
  type: GET_BASKET,
})

export const getBasketSucces = (products: BasketItem[], vatTotal: number): GetBasketSuccessAction => ({
  type: GET_BASKET_SUCCESS,
  payload: 
  { 
    items: products,
    vatTotal: vatTotal 
  },
})

export const setBasketProducts = (
  products: BasketItem[],
): SetBasketProductsAction => ({
  payload: products,
  type: SET_BASKET_PRODUCTS,
})

export const purgeBasket = (): PurgeBasketAction => ({
  type: PURGE_BASKET,
})

export const removeProductFromBasket = (
  product: WebshopPackage,
): RemoveProductFromBasketAction => ({
  payload: product,
  type: REMOVE_PRODUCT_FROM_BASKET,
})

export const removeProductFromBasketSuccess = (): RemoveProductFromBasketSuccessAction => ({
  type: REMOVE_PRODUCT_FROM_BASKET_SUCCESS,
})

export const startPayment = (
  payload: StartPaymentAction['payload'],
): StartPaymentAction => ({
  payload,
  type: START_PAYMENT,
})

export const rebuildWebshop = (
  payload: RebuildWebshopAction['payload'],
): RebuildWebshopAction => ({
  payload,
  type: REBUILD_WEBSHOP,
})
